import { Box, Grid, Stack } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";

//IDOGAN;453142;02042025

interface ChangePanelProps {
  defaultProcessType?: string;
  mode?: "edit" | "remove" | "create";
}
const ChangePanel = ({ defaultProcessType, mode }: ChangePanelProps) => {
  const { t } = useTranslate();
  const processOptions = [
    {
      value: "removal-operation",
      label: t("catheter-material-tracking.removal-operation"),
    },
  ];
  return (
    <Box
      sx={{
        padding: "20px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          md={6}
          xs={6}
          mb={1}
          sx={{
            backgroundColor: "#F4F7FE",
            borderBottom: "1px solid #E0E0E0",
            height: "100%",
            maxHeight: "56px",
            alignItems: "center",
            display: "flex",
          }}
        >
          <ByzMuiTypography isTitle sx={{ textAlign: "left" }}>
            {t("catheter-material-tracking.catheter-material-procedures")}
          </ByzMuiTypography>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.material-type")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              disabled={mode === "remove" || mode === "edit"}
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.material-name")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              disabled={mode === "remove" || mode === "edit"}
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.entry-location")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              disabled={mode === "remove" || mode === "edit"}
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.region")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              disabled={mode === "remove"}
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.expected-duration")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <Stack direction="row" spacing={1}>
              <ByzMuiSelect
                disabled={mode === "remove"}
                sx={{ width: "100%" }}
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
                options={[]}
                label={t("select")}
                placeholder={t("select")}
              />
              <ByzMuiSelect
                disabled={mode === "remove"}
                sx={{ width: "100%" }}
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
                options={[]}
                label={t("select")}
                placeholder={t("select")}
              />
            </Stack>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.stay-duration")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              disabled={mode === "remove" || mode === "edit"}
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.staff")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.application-date")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.procedure-type")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              sx={{ width: "100%" }}
              multiple={false}
              disableClearable
              disabled={!!defaultProcessType}
              value={
                defaultProcessType
                  ? processOptions.find(
                      (opt) => opt.label === defaultProcessType
                    )
                  : null
              }
              options={processOptions}
              label="label" // options içindeki property adıyla eşleşmeli
              placeholder={t("select")}
              renderInput={(params: any) => (
                <ByzMuiTextField {...params} label={t("select")} />
              )}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.reason")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiSelect
              sx={{ width: "100%" }}
              renderInput={(params: any) => <ByzMuiTextField {...params} />}
              options={[]}
              label={t("select")}
              placeholder={t("select")}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Grid
            md={6}
            xs={6}
            sx={{
              borderBottom: "1px solid #E0E0E0",
              height: "100%",
              alignItems: "center",
              display: "flex",
            }}
          >
            <ByzMuiTypography sx={{ marginLeft: "30px" }}>
              {t("catheter-material-tracking.description")}
            </ByzMuiTypography>
          </Grid>
          <Grid md={6} xs={6}>
            <ByzMuiTextField
              disabled={mode === "remove" || mode === "edit"}
              sx={{ width: "100%" }}
              label={t("note")}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChangePanel;
